import { IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar 
,IonList, IonItemDivider, IonItemGroup, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent
,IonThumbnail, IonBackButton, IonInfiniteScroll, IonInfiniteScrollContent
,IonImg, IonButton,
IonIcon
} from '@ionic/react';
//import { useParams } from 'react-router';
import './WpDtl.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import { chevronBackOutline, camera, trash, close, checkmarkCircle, qrCodeOutline, arrowRedo, closeCircle } from 'ionicons/icons';
import { setAuthPersisted } from '../../../services/pinUtils';
type WpFormParams = {
  id:string, 
  dummy:string
}
  const WpIdCheck: React.FC = () => {
  const {id, dummy} = useParams<WpFormParams>();
  const server = new ServerService();
  const history = useHistory();
  server.setHistory(history);
  const [fullname, setFullname] = useState("");
  const [citizenid, setCitizenid] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [pos, setPos] = useState("");
  const [telephone, setTelephone] = useState("");
  const [email, setEmail] = useState("");
  const [trainingdate, setTrainingdate] = useState("");
  const [profileimage, setProfileimage] = useState("");
  const [cert_img, setCertImg] = useState("");
  const [cert_train_img, setCertTrainImg] = useState("");
  const [hideCert, setHideCert] = useState(true);
  const [hideCertTrain, setHideCertTrain] = useState(true);
  const data = {
    docid: id
  }
  useEffect(() => {
    fetchContractor(id);
  }, [])
  const fetchContractor = function(uuid:any) {
    const data = {
      cbarcode: uuid
    }
    fetch(server.getFullUrl("wp/mb/getContractor", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        setFullname(result.fullname);
        setCitizenid(result.citizenid);
        setCompanyname(result.companyname);
        setTelephone(result.telephone);
        setPos(result.pos);
        setEmail(result.email);
        setTrainingdate(result.trainingcouse[0].trainingdate);
        setProfileimage(result.profileimage);
        setCertImg(result.cert_img);
        setCertTrainImg(result.cert_train_img);
        if(result.cert_img!=null){
          setHideCert(false);
        }
        if(result.cert_train_img!=null){
          setHideCertTrain(false);
        }
        console.log('fetchContractor');
      },
      (error) => {
  
      }
   ).catch(e => {
  
   })
  ).catch(e => {
  
  }) 
  }
  const onBack = function() {
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpForm/0/d";
  }
  const onDownloadCert = function(nodeRef:any) {

    window.open(server.getFullUrl("rp/downloadFile?alf_ticket="+server.state.ticket+"&nodeRef="+nodeRef, null));
   
  }
  const onDownloadPermit = function(nodeRef:any) {
  
    window.open(server.getFullUrl("rp/downloadFile?alf_ticket="+server.state.ticket+"&nodeRef="+nodeRef, null));
   
  }
  return (
    
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons onClick={(e) => onBack()} slot="start">
          <IonIcon icon={chevronBackOutline}></IonIcon>
          </IonButtons>
          <IonTitle>ผู้ขออนุญาต</IonTitle>
        </IonToolbar>
      </IonHeader>
        <IonContent>
         <div className="card-middel">
            <IonCard>    
            <img className="img-profile2" src={profileimage}/ >
            <IonCardHeader>
            <IonCardTitle>{fullname}</IonCardTitle>
            <IonCardSubtitle>{companyname}</IonCardSubtitle>
            <IonCardSubtitle>เลขบัตรประชาชน : {citizenid}</IonCardSubtitle>
            <IonCardSubtitle>เบอร์ติดต่อ : {telephone}</IonCardSubtitle>
            <IonCardSubtitle>ตำแหน่ง : {pos}</IonCardSubtitle>
            <IonCardSubtitle>Email : {email}</IonCardSubtitle>
            <IonCardSubtitle>ประวัติการอบรม : {trainingdate}</IonCardSubtitle>
            {!hideCert ? (
                <IonButton hidden={hideCert} onClick={() => onDownloadCert(cert_img)} fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;ใบอบรมความปลอดภัย(6ชั่วโมง)</IonButton>
            ) :""}
            {!hideCertTrain ? (
               <IonButton hidden={hideCertTrain} onClick={() => onDownloadPermit(cert_train_img)} fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;ใบอนุญาติ/ใบผ่านการอบรม</IonButton>
            ) :""}
            
            </IonCardHeader>
            <IonCardContent></IonCardContent>
            </IonCard>
            </div>
      </IonContent>
    </IonPage>
  );
};

export default WpIdCheck;
